// removed by extract-text-webpack-plugin
module.exports = {"form":"Form__form__t236C","error":"Form__error__1PT04"};


//////////////////
// WEBPACK FOOTER
// ./src/components/controls/Form.scss
// module id = 641
// module chunks = 0